import { useEffect, useState } from "react";
import { ICartItem, ICartOption } from "../../../../../../../../Interfaces/componentTypes";
import { IMenuItemResponce } from "../../../../../../../../Interfaces/responseTypes";
import useLanguagesHooks from "../../../../../../../../Components/Languages/setLanguage-hooks";
import { IMenuItemDialogProps } from "./menuItemDialog";
import useDialogHooks from "../../../../../../../../Components/Dialog/dialog-hooks";

const useMenuItemDialog = (props: IMenuItemDialogProps) => {
    const { category, itemData, mainCart } = props;
    const currentCategory = category.category;
    const existingItem = mainCart.find((item) => item.id === itemData.id);
    const { open, onOpen: onOpenNoteDialog, onClose: onCloseNoteDialog } = useDialogHooks();
    const initialCart: ICartItem = existingItem || {
        category: {
            id: currentCategory.id,
            name_en: currentCategory.name_en,
            name_hy: currentCategory.name_hy,
            name_ru: currentCategory.name_ru
        },
        id: itemData.id,
        image: itemData.image,
        name_hy: itemData.name_hy,
        name_en: itemData.name_en,
        name_ru: itemData.name_ru,
        cooking_time: itemData.cooking_time,
        cooking_time_unit: itemData.cooking_time_unit,
        option: [],
        note: undefined
    };

    if (!existingItem && itemData.option.length === 1) {
        const singleOption = itemData.option[0];
        initialCart.option = [{
            option_id: singleOption.option_id,
            measure_type: singleOption.measure_type,
            measure_value: singleOption.measure_value,
            price: singleOption.price,
            package_cost: singleOption.package_cost!,
            count: 1,
        }];
    }

    const { activeLanguage } = useLanguagesHooks();
    const [cart, setCart] = useState<ICartItem>(initialCart);
    const localizedTitle = itemData[`name_${activeLanguage}` as keyof IMenuItemResponce] || itemData.name_en;
    const localizedDescription = itemData[`description_${activeLanguage}` as keyof IMenuItemResponce] || itemData.name_en;
    const [total, setTotal] = useState<number>(itemData.option.length === 1 ? Number(itemData.option[0].price) : 0);
    const isButtonActive = cart.option.length > 0;
    const [animate, setAnimate] = useState<boolean>(false);

    useEffect(() => {
        if (Array.isArray(cart.option) && cart.option.length > 0) {
            setTotal(calculateTotalPrice(cart))
        } else {
            setTotal(0)
        }
    }, [cart]);

    useEffect(() => {
        if (total > 0 && animate === false) {
            setAnimate(true)
        } else if (total < 1 && animate === true) {
            setAnimate(false)
        }
    }, [total]);

    const calculateTotalPrice = (cart: ICartItem): number => {
        let totalPrice = 0;
        for (const option of cart.option) {
            const optionPrice = parseFloat(option.price) || 0;
            totalPrice += optionPrice * option.count;
        }
        return totalPrice;
    };

    const handleAddNote = (note: string) => {
        setCart((prevCart) => ({
            ...prevCart,
            note: note.trim() || undefined,
        }));
        onCloseNoteDialog();
    };

    const handleAddOption = (option: ICartOption, count: number) => {
        setCart((prevCart) => {
            const existingOptionIndex = prevCart.option.findIndex(
                (opt) => opt.option_id === option.option_id
            );

            if (existingOptionIndex !== -1) {
                const updatedOptions = [...prevCart.option];
                updatedOptions[existingOptionIndex].count = Math.max(0, updatedOptions[existingOptionIndex].count + count);

                if (updatedOptions[existingOptionIndex].count <= 0) {
                    updatedOptions.splice(existingOptionIndex, 1);
                }

                return { ...prevCart, option: updatedOptions };
            } else {
                if (count <= 0) {
                    return prevCart;
                }
                return {
                    ...prevCart,
                    option: [
                        ...prevCart.option,
                        {
                            option_id: option.option_id,
                            measure_type: option.measure_type,
                            measure_value: option.measure_value,
                            price: option.price,
                            package_cost: option.package_cost!,
                            count,
                        },
                    ],
                };
            }
        });
    };

    return {
        open,
        cart,
        total,
        animate,
        existingItem,
        localizedTitle,
        isButtonActive,
        localizedDescription,
        handleAddNote,
        handleAddOption,
        onOpenNoteDialog,
        onCloseNoteDialog,
    }
};

export default useMenuItemDialog